import React, { useEffect, useContext } from 'react';
import { GeneralContext } from '../../context/generalContext';
import classes from './ModalPopup.module.scss';

export default function ModalPopup({ showModal, targetRef, text, onCloseModal }) {
  const { activeLanguage } = useContext(GeneralContext);
  // заморозить область за модальным если оно открыто
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = 'visible';
      document.body.style.position = '';
      document.body.style.width = '';
    }
  }, [showModal]);

  return (
    <div className={classes.msgModal} ref={targetRef} data-show={showModal ? 'true' : 'false'}>
      <div
        className={classes.modalBox}
        style={{
          maxWidth: '820px',
        }}
      >
        <div className={classes.modal}>
          <div className={classes.textDiv}>
            {text?.title && (
              <div
                className={classes.title}
                dangerouslySetInnerHTML={{
                  __html: activeLanguage === 1 ? text?.title : text?.title_en || text?.title,
                }}
              />
            )}
            {text?.text && (
              <div
                className={classes.text}
                dangerouslySetInnerHTML={{
                  __html: activeLanguage === 1 ? text?.text : text?.text_en || text?.text,
                }}
              />
            )}

            <button className={classes.mobileCloseBtn} onClick={() => onCloseModal()} />
          </div>
        </div>

        <button className={classes.modalCloser} onClick={() => onCloseModal()} />
      </div>
      <div className={classes.overlay} onClick={() => onCloseModal()} />
    </div>
  );
}
